import { useQuery } from '@tanstack/react-query';
import { fetchSchedules } from '../../api';

export function useSchedules(bookable: boolean, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['schedules', { bookable }],
    queryFn: () => fetchSchedules(bookable),
    enabled,
  });
}
